export enum SettingsExpressionsDataEventObjectsEnum {
  ADD_EXPRESSION = 'add_expression',
  CREATE_EXPRESSION = 'create_expression',
  EDIT_EXPRESSION = 'edit_expression',
}
